// src/Layout/Header/Header.jsx
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Breadcrumb from './Breadcrumb';
import SearchBar from './SearchBar';
import OnlineStatus from './Onlinestatus';
import SyncButton from './Syncbutton';
import NotificationIcon from './Notification';
import UserProfile from './Userprofile';

const Header = ({ onOpenSidebar }) => {
  const location = useLocation();
  const showSearchBar = ['/executive-overview', '/dashboard'].includes(location.pathname);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="relative z-20 flex h-[60px] shrink-0 items-center justify-between gap-3 border-b border-gray-100 bg-white px-4 lg:px-6">
      <div className="flex min-w-0 items-center gap-2">
        <button
          type="button"
          className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 text-gray-600 hover:bg-gray-50 lg:hidden"
          onClick={() => {
            setIsMobileMenuOpen(false);
            onOpenSidebar?.();
          }}
          aria-label="Open sidebar"
          aria-controls="app-sidebar"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        {/* Breadcrumb is fully self-contained - reads URL via useLocation internally */}
        <div className="min-w-0">
          <Breadcrumb />
        </div>
      </div>

      <div className="hidden items-center gap-3 lg:flex">
        <OnlineStatus />
        <SyncButton />
        <NotificationIcon />
        <UserProfile />
      </div>

      <div className="relative lg:hidden">
        <button
          className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 text-gray-600 hover:bg-gray-50"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        {isMobileMenuOpen && (
          <div className="absolute right-0 top-full z-[100] min-w-[200px] rounded-md border border-gray-200 bg-white px-4 py-3 shadow-lg">
            <div className="flex flex-col gap-3">
              {showSearchBar && <SearchBar />}
              <OnlineStatus />
              <SyncButton />
              <NotificationIcon />
              <UserProfile />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
